import 'iframe-resizer';

[...document.querySelectorAll('[data-iframe-resizer]')].forEach((iframe) => { window.iFrameResize({}, iframe) });
